export default __webpack_public_path__ + "static/media/cloud-icon.2514ac47.svg";